import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { checkInputErrorMaxLength, checkInputErrorRequired, usePathParam, useTextarea } from '@chilecompra/react-kit'
import { Button, Toast, Typography, Textarea } from '@chilecompra/react-kit/components'
import routes from '../../config/settings/routes'
import { onCancelQuoteThunk, onCloseCancelQuoteDialog } from './CancelQuoteDialog.actions'
import { CircleErrorIcon, Dialog, Row, Strong } from './CancelQuoteDialog.styles'

/**
 * The CancelQuoteDialog's container.
 */
const CancelQuoteDialog = () => {
  const { error, loading, open } = useSelector(state => state.cancelQuoteDialog)
  const quoteID = usePathParam('quoteId')
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const {
    error: justificationError,
    onChange: handleJustificationChange,
    value: justificationValue
  } = useTextarea({
    errorCallbacks: [checkInputErrorMaxLength(500), checkInputErrorRequired()]
  })

  const handleClickCloseDialog = () => dispatch(onCloseCancelQuoteDialog())
  // TODO: redirect after canceling the quote
  const handleClickCancel = () => {
    dispatch(
      onCancelQuoteThunk({
        quoteID,
        justification: justificationValue,
        callback: () => navigate(routes.search)
      })
    )
  }

  const disableSubmit = justificationValue === ''

  return (
    <Dialog disableBackdropClick open={open} verticalAlign="top" onClose={handleClickCloseDialog}>
      <Row justifyContent="center" margin="32px 0 0">
        <CircleErrorIcon fontSize="64px" />
      </Row>
      <Row justifyContent="center" margin="16px 0 0">
        <Typography fontWeight="bold" variant="h4">
          Cancelar Compra Ágil
        </Typography>
      </Row>
      <Row justifyContent="center">
        <Typography align="center" margin="16px 0 0" variant="body2">
          Se cancelará la Compra Ágil correspondiente al ID {quoteID}.<Strong> Esta acción es irreversible</Strong>. La
          justificación ingresada será visible en la ficha para todos los proveedores.
        </Typography>
      </Row>
      <Row justifyContent="center">
        <Textarea
          error={justificationError}
          label="Justificación"
          margin="21px 0 0 0"
          maxCount={500}
          multiline
          onChange={handleJustificationChange}
          value={justificationValue}
          width="75%"
        />
      </Row>
      <Row margin="24px 0 0">
        {/* FIXEME: waiting for correct error handling from backend */}
        {!loading && error && (
          <Toast severity="error" title="Lo sentimos, no pudimos cancelar tu Compra Ágil.">
            Por favor, consulta en unos minutos más.
          </Toast>
        )}
      </Row>
      <Row justifyContent="space-between" margin="27px 0 12px">
        <Button onClick={handleClickCloseDialog} variant="contained">
          Volver
        </Button>
        <Button color="error" disabled={disableSubmit} variant="outlined" type="submit" onClick={handleClickCancel}>
          Cancelar Compra Ágil
        </Button>
      </Row>
    </Dialog>
  )
}

export default CancelQuoteDialog
